import React, { useState } from 'react'
import Classes from './Dashboard.module.css'
import Hero1 from './Comp/Hero1';
import RecordTable from './Comp/RecordTable/RecordTable';
import Hero2 from './Comp/Hero2/Hero2';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const navigateTo = useNavigate();

  return (
    <>
      <div className={Classes.hero} >
        <Hero1 />
        <Hero2 />
        <RecordTable />
      </div>
    </>
  )
}
